module.exports = "<div class=ws-expander> <div class=\"ws-expander__header base-padding\"> <div class=ws-expander__header--content ng-transclude=header ng-style=\"{ width: $ctrl.headerContentWidth }\"> </div> <a class=ws-expander__toggle ng-click=$ctrl.toggle() ng-style=\"{ width: $ctrl.toggleWidth }\"> {{ $ctrl.getToggleText() }} </a> </div> <div class=\"ws-expander__body base-padding\" ng-transclude=body ng-show=$ctrl.isExpanded()> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/expander/expander.tmpl.html
// module id = 91
// module chunks = 0